import type React from 'react';

import { Alert } from '@change/ds-core-ui';

type Video = { videoUrl: string };

const DeleteSuccessMessage: React.FC<{ video: Video }> = ({ video }) => {
	return (
		<Alert variant="success" heading="Success" className="mb-2">
			{video.videoUrl ? 'Video' : 'Comment'} Successfully removed.
		</Alert>
	);
};

const DeleteErrorMessage: React.FC = () => {
	return (
		<Alert variant="warning" heading="Delete failed" className="mb-2">
			Something went wrong while deleting.
		</Alert>
	);
};

export const PetitionVideoDeleteMessage: React.FC<{
	message: 'success' | 'error' | undefined;
	video: Video;
}> = ({ message, video }) => {
	if (message === 'success') return <DeleteSuccessMessage video={video} />;
	if (message === 'error') return <DeleteErrorMessage />;
	return null;
};
